import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { FlexContainer } from 'theme/Grid';
import { SiteHeader, SiteLogo, SiteLogoWrapper, Navigation, MobileNavigationToggle, ToggleBurger, MobileNavigation } from 'components/Header.style.js';
import LogoImage from 'assets/my-vagrant-life-logo.png';

class Header extends Component {

  constructor(){
    super();
    this.state = { showMobileNav: false };
    this.toggleNav = this.toggleNav.bind(this);
  }

  toggleNav(event, obj) {
    let toggleState = !this.state.showMobileNav;
    this.setState({'showMobileNav': toggleState});
  }

  render() {
    const photographyPages = ['/', '/astro-photography', '/travel-photography'];
    const digitalNomadPages = ['/freelance-web-design-development', '/digital-photo-editing-retouching'];
    const contactPages = ['/work-with-me', '/contact'];

    const isPhotographyPageActive = photographyPages.indexOf(window.location.pathname) > -1 ? true: false;
    const isDigitalNomadPageActive = digitalNomadPages.indexOf(window.location.pathname) > -1 ? true: false;
    const isContactPageActive = contactPages.indexOf(window.location.pathname) > -1 ? true: false;

    return (
      <SiteHeader>
        <FlexContainer>
          <SiteLogoWrapper>
            <NavLink exact to='/' activeClassName='current-item'>
              <SiteLogo src={ LogoImage } className="site-logo" />
            </NavLink>
            <NavLink exact to='/' activeClassName='current-item'>
              <h2>Edward Smith</h2>
              <h1>My Vagrant Life</h1>
            </NavLink>
          </SiteLogoWrapper>
          <Navigation>
            <NavLink exact to='/' className={ isPhotographyPageActive ? ' current-item': ''}>Photography</NavLink>
            <NavLink to='/freelance-web-design-development' className={ isDigitalNomadPageActive ? ' current-item': ''}>Digital Nomad</NavLink>
            <NavLink to='/work-with-me' className={ isContactPageActive ? ' current-item': ''}>Contact</NavLink>
          </Navigation>
        </FlexContainer>
        <MobileNavigationToggle onClick={this.toggleNav}>
          <ToggleBurger active={this.state.showMobileNav ? true: false} />
        </MobileNavigationToggle>
        <MobileNavigation style={{'display': this.state.showMobileNav ? 'block': 'none'}}>
          <NavLink exact to='/' onClick={this.toggleNav} className={ isPhotographyPageActive ? ' current-item': ''}>Photography</NavLink>
          <NavLink to='/freelance-web-design-development' onClick={this.toggleNav} className={ isDigitalNomadPageActive ? ' current-item': ''}>Digital Nomad</NavLink>
          <NavLink to='/work-with-me' onClick={this.toggleNav} className={ isContactPageActive ? ' current-item': ''}>Contact</NavLink>
        </MobileNavigation>
      </SiteHeader>
    );
  }
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js